import { ToolContent, ToolHeader } from '@crowdex/ui/ai/tool';
import { toolCallGroupModel } from '@/lib/conversations/message-part/tool-group';
import type { ToolActivityPart } from '@/lib/conversations/message-part/types';
import { DiffCounts } from './diff-counts';
import { DynamicTool } from './dynamic-tool';
import { DesktopMessagePart } from './message-part';
import { StableTool } from './stable-tool';

export function ToolCallGroup({
  onOpenTerminal,
  parts,
}: {
  onOpenTerminal?: (terminalId: string) => void;
  parts: readonly ToolActivityPart[];
}) {
  const {
    diffTotals,
    hasDiff,
    progressTitle,
    state,
    summary,
    terminalsByToolCallId,
    visibleParts,
  } = toolCallGroupModel(parts);
  return (
    <StableTool className="text-muted-foreground">
      <ToolHeader
        action={summary.action}
        className="py-0.5"
        details={
          hasDiff ? (
            <DiffCounts additions={diffTotals.additions} deletions={diffTotals.deletions} />
          ) : undefined
        }
        state={state}
        title={progressTitle}
        type={summary.type}
      />
      <ToolContent>
        <div className="py-1">
          {visibleParts.map((part, index) =>
            part.type === 'dynamic-tool' ? (
              <DynamicTool
                key={part.toolCallId}
                onOpenTerminal={onOpenTerminal}
                part={part}
                terminal={terminalsByToolCallId.get(part.toolCallId)}
              />
            ) : (
              <DesktopMessagePart
                // biome-ignore lint/suspicious/noArrayIndexKey: Several parts can share a tool call; they are positions in the group.
                key={`${part.data.toolCallId}-${index}`}
                onOpenTerminal={onOpenTerminal}
                part={part}
              />
            ),
          )}
        </div>
      </ToolContent>
    </StableTool>
  );
}
